import React, { useState } from 'react'
import SoftBox from "components/SoftBox";
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";



const SERVER_URL = process.env.REACT_APP_API_URL;
function SearchScreen({ handleCard }) {

  const [continueButton, setContinueButton] = useState(false)
  const[disable,setDisable]=useState(false)


  const [formData, setFormData] = useState({
    shop_code: "",
  })

  const [retailerDetails, setRetailerDetails] = useState({
    retailer_code: "",
    retailer_name: "",
    retailer_company_name: "",
    address: "",
  })



  const handleSearch = async (e) => {
    e.preventDefault();
    for (const key in formData) {
      if (!formData[key]) {
        toast.error(" Please enter retailer id  to continue")
        return; 
      }
    }
    try {
      const header = await getApiHeader()
      const params = new URLSearchParams();
      for (const key in formData) {
        if (formData[key]) {
          params.append(key, formData[key]);
        }
      }
      const response = await axios.get(`${SERVER_URL}sell-physical-recharge-vouchers/search?${params.toString()}`, { headers: header });

      if (response.status === 200) {
        setDisable(false)
        const data = response.data.data
        toast.success(response.data.message)
        sessionStorage.setItem('search-ID', data.retailer_id);
        
        setRetailerDetails({
          ...retailerDetails,
          retailer_code: data.retailer_code,
          retailer_name: data.retailer_name,
          retailer_company_name: data.retailer_company_name,
          address: data.address
        })
        setContinueButton(true)
      }

    } catch (error) {
      setDisable(false)
      toast.error(error.response.data.message)

    }
  }


  const handleChange = (event) => {
    setDisable(false)
    setContinueButton(false)
    const { name, value } = event.target
    setFormData({
      ...formData,
      [name]: value,
    })
  }


  const handleContinue = () => {
    handleCard(true)
  }


  return (
    <div>
      <div className="formbold-main-wrapper">
        <div className="formbold-form-wrapper">
          <h3 style={{ textAlign: "center" }}>Sell Physical Recharge Vouchers </h3>
          <form action="" method="" onSubmit={handleSearch}>
            <div className="formbold-mb-5 formbold-pt-3">
              <label className="formbold-form-label formbold-form-label-2">
              </label>
              <div className="flex flex-wrap formbold--mx-3 upload-form">
                <div className="w-full sm:w-half formbold-px-3 ">
                  <div className="formbold-mb-5 ">
                    <label htmlFor="store_name" className="formbold-form-label">
                      Retailer Id <span class="astrix-color">*</span>
                    </label>
                    <input
                      type="text"
                      name="shop_code"
                      id="shop_code"
                      placeholder="Enter Retailer Id"
                      className="formbold-form-input"
                      value={formData.shop_code}
                      onChange={handleChange}
                      autoComplete='off'
                    />
                  </div>
                </div>
              </div>
            </div>


            {continueButton &&
              <div className="formbold-main-wrapper  ">
                <SoftBox component="form" role="form" style={{ width: "auto" }} mx={"5%"}>
                  <SoftBox mb={2}>
                    <div className="recharge-details">
                    <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th style={{textAlign:'left', fontSize:'12px'}}>Dealer Name</th>
                          <td style={{textAlign:'left', fontSize:'12px'}}> {retailerDetails.retailer_name}</td>
                          </tr>
                          <tr>
                            <th style={{textAlign:'left', fontSize:'12px'}}>Company/Store Name</th>
                            <td style={{textAlign:'left', fontSize:'12px'}}> {retailerDetails.retailer_company_name}</td>
                          </tr>
                          <tr>
                            <th style={{textAlign:'left', fontSize:'12px'}}>Dealer Address</th>
                            <td style={{textAlign:'left', fontSize:'12px'}}> {retailerDetails.address}</td>
                          </tr>
                        </tbody>
                      </table>

                      {/* <p className='details-name'>Dealer Name: <span>{retailerDetails.retailer_name}</span></p>
                      <p className='details-company' >Company/Store Name: <span>{retailerDetails.retailer_company_name}</span></p>
                      <p className='details-address'>Dealer Address: <span>{retailerDetails.address}</span></p> */}
                    </div>
                  </SoftBox>
                </SoftBox>
              </div>
            }
            <div className="search-store-buttons">
              {continueButton ?
                <button className="search-store-button" type="submit" onClick={handleContinue}>Continue <i class="fa fa-angle-double-right"></i></button>
                :
                <button className="search-store-button" type="submit"><i class="fa fa-search" disabled={disable}></i> Search </button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SearchScreen